<template>
  <div>
    <v-dialog v-model="dialog" max-width="800px" persistent scrollable>
      <v-card>
        <v-card-title class="primary white--text text-uppercase dialog-title">
          Xếp phòng thi
          <v-spacer></v-spacer>
          <v-btn dark icon>
            <v-icon @click="cancel" class="mr-n1" :disabled="loading">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-0">
          <StudentExamCard :item="item.student" />
          <v-divider></v-divider>
          <StudentRoomTable :data="item" :rooms="rooms" :subjects="subjects" @closeDialog="cancel" class="pb-6" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-6">
          <v-btn color="primary" @click="cancel" width="118" :loading="loading" large outlined>Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="cancel" :loading="loading" width="118" class="white--text elevation-0" large
            >Xác nhận</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import StudentExamCard from './StudentExamCard.vue'
import StudentRoomTable from './StudentRoomTable.vue'
export default {
  props: {
    item: Object,
    rooms: Array,
    subjects: Array,
    state: Boolean
  },
  components: {
    StudentExamCard,
    StudentRoomTable
  },

  watch: {
    state(state) {
      this.dialog = state
      if (!state) {
        this.loading = false
        this.progressDialog = false
      }
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      confirmDialog: false,
      progressDialog: false,
      importOrigin: '',
      room: {},
      progress: 0
    }
  },
  methods: {
    cancel() {
      this.$emit('closeDialog')
    }
  }
}
</script>
